<template>
  <v-row>
    <v-col cols="12">
      <v-date-input
        v-model="dates"
        :append-inner-icon="filter.icon"
        :clearable="filter.clearable ?? false"
        :label="label"
        :density="dense"
        variant="outlined"
        multiple="range"
        prepend-icon=""
        hide-details
        :disabled="$loader.loading"
        @click.clear="handleClear"
      />
    </v-col>
  </v-row>
</template>

<script lang="ts">
import { type PropType, defineComponent } from 'vue'
import { VDateInput } from 'vuetify/labs/VDateInput'

import { type FiltersProps } from '@/types/DataTable'
import type DensityProp from '@/types/vuetify/Density'

export default defineComponent({
  components: {
    VDateInput,
  },
  props: {
    modelValue: {
      type: [Object, Date] as PropType<object | Date | Date[] | null>,
      required: true,
    },
    filter: {
      type: Object as PropType<FiltersProps>,
      default: () => ({}),
    },
    dense: {
      type: String as PropType<DensityProp>,
      default: 'default',
    },
  },
  emits: [ 'update:modelValue' ],
  data() {
    return {
      dates: Array.isArray(this.modelValue)
        ? this.modelValue
        : null,
    }
  },
  computed: {
    label() {
      return this.filter?.label ?? 'Data'
    },
  },
  watch: {
    dates(newValue): void {
      this.$emit('update:modelValue', newValue)
    },
  },
  methods: {
    handleClear() {
      this.dates = []
    },
  },
})
</script>
